import { translate } from '@micro-apps/env';

export default function useTranslation() {
	return {
		t: (str, params) => translate(str, params),
	};
}
